module.exports = __webpack_public_path__ + "static/media/consultant.6a4fd351.svg";